import { parseLinkVerified } from '@qr.kg/elqr-js';

// Preserve transport encoding when moving a fragment between bank routers.
export const extractElqrPayload = (source?: string): string | null => {
    if (!source) return null;
    const hashIndex = source.indexOf('#');
    if (hashIndex >= 0) return source.slice(hashIndex + 1) || null;
    return source.startsWith('000201') ? source : null;
};

export const verifyElqrPayload = async (source?: string): Promise<string | null> => {
    const payload = extractElqrPayload(source);
    if (!payload) return null;
    try {
        await parseLinkVerified(payload);
        return payload;
    } catch {
        return null;
    }
};
